export default "__VITE_ASSET__DotM5A9k__"